import React, { useRef } from "react";
import { DualAxes } from "@ant-design/charts";

const basic = {
	xField: "key",
	yField: ["value", "Line"],
	autoFit: true,
};

const label = {};
const legend = {
	position: "top",
};

export default function GroupedColumnLineChart(
	chartData = [],
	chartConfig = {}
) {
	let dataOne = [],
		dataTwo = [];
	for (let i = 0; i < chartData.length; i++) {
		dataOne.push({
			type: chartData[i].type,
			key: chartData[i].key,
			value: chartData[i].value[0],
		});
		if (chartData[i].value[1] >= 0 || chartData[i].value[1] < 0) {
			dataTwo.push({
				type: chartData[i].type,
				key: chartData[i].key,
				Line: chartData[i].value[1],
			});
		}
	}
	const config = {
		data: [
			dataOne.length
				? dataOne
				: [
						{
							key: "",
							value: "",
							type: "",
						},
				  ],
			dataTwo,
		],
		...basic,
		geometryOptions: [
			{
				geometry: "column",
				isGroup: true,
				seriesField: "type",
				color: ["#5B8FF9", "#5D7092"],
				label: chartConfig.label ? label : false,
			},
			{
				geometry: "line",
				lineStyle: {
					lineWidth: 2,
				},
				color: "#5AD8A6",
			},
		],
		legend: chartConfig.legend ? legend : false,
	};
	const ref = useRef();

	return <DualAxes {...config} chartRef={ref} />;
}
